exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".os-toggler-w.on .os-toggler-i {\n  background-color: #dde2ec; }\n  .os-toggler-w.on .os-toggler-i .os-toggler-pill {\n    background-color: #008e57; }\n\n.os-toggler-w.off .os-toggler-i {\n  background-color: #dde2ec; }\n  .os-toggler-w.off .os-toggler-i .os-toggler-pill {\n    background-color: #ff4a50; }\n", ""]);

// exports
